import { useContext } from 'react';
import { MapGlobalContext } from '../context/map-global-context';

export const useEsriMapStore = () => {
    const mapGlobalContext = useContext(MapGlobalContext);

    if (!mapGlobalContext || !mapGlobalContext?.esriMapStore)
        throw new Error("Couldn't find esriMapStore");

    return mapGlobalContext.esriMapStore;
};
